import { useEffect } from "react";
import { useState } from "react";
import useSWR from "swr";
import { LatestJournalMessageType, LatestJournalResponseSchema } from "@/types/schemas";
import { fetcherTyped } from "@/lib/utils";

export const useLatestJournal = (
  run: boolean,
  taskId?: string,
  refreshInterval?: number,
  limit?: number
) => {
  const { data, mutate } = useSWR(
    run
      ? "/api/journal/latest?sortBy=id&sortOrder=desc&" +
          [taskId ? "taskId=" + taskId : "", limit ? "limit=" + limit : ""]
            .filter(s => s !== "")
            .join("&")
      : null,
    fetcherTyped(LatestJournalResponseSchema),
    { refreshInterval }
  );

  const [latest, setLatest] = useState<LatestJournalMessageType[]>([]);

  useEffect(() => {
    const logs = data?.logs || [];
    setLatest(
      logs.map(l => {
        const m = l as unknown as LatestJournalMessageType;
        return {
          ...m,
          taskType: m.task?.type
        };
      })
    );
  }, [data]);

  return {
    latest,
    mutate
  };
};
